/**
 * Single source of truth for site-level (landing `/`) SEO strings.
 *
 * Consumed by the React `<Seo>` component (runtime head tags + JSON-LD) and
 * mirrored by the static tags in `packages/ui/index.html` (the baseline that
 * non-JavaScript link-preview scrapers read). A coherence test
 * (`index-html-seo-coherence.test.ts`) asserts the static `index.html` stays in
 * sync with these values.
 */
export const SITE_METADATA = {
  /** Brand name used in `<title>` suffix, Organization/WebSite `name`. */
  siteName: 'Altar',
  /** Canonical absolute origin (no trailing slash). */
  siteUrl: 'https://altar.fund',
  /** Landing `<title>`. Kept under ~60 chars for SERP display. */
  landingTitle: 'Altar — Sacrifice across 31 blockchains',
  /** Landing meta description. Kept under ~155 chars for SERP display. */
  landingDescription:
    'A public, auditable way to sacrifice tokens across 31 blockchains. Connect a wallet, pick a campaign, send directly from self-custody, and earn points.',
  /** Absolute URL of the Open Graph / Twitter share image. */
  ogImage: 'https://altar.fund/altar-og.png',
  /** Twitter card type. `summary_large_image` once a wide hero asset exists. */
  twitterCard: 'summary',
} as const

/**
 * Structural shape for passing metadata into the SEO helpers and `<Seo>`
 * component: any object with the required string fields. `SITE_METADATA`
 * (declared `as const` above) satisfies this; tests pass spread variants.
 */
export interface SiteMetadata {
  siteName: string
  siteUrl: string
  landingTitle: string
  landingDescription: string
  ogImage: string
  twitterCard: string
}
